import React, { useState } from "react";
import { useForm } from "react-hook-form";
import FormProcessingSpinner from "./FormProcessingSpinner";
import paths from "../../constants/paths";
import { doObjToFormData } from "../../helpers/helpers";
import http from "../../helpers/http";
import { toast, ToastContainer } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";

function ReportPopup2({ handleToggleReportPopup, post }) {
  const POST_REPORT_REASONS = [
    "This post contains inappropriate or offensive content.",
    "This post is spam or promotional in nature.",
    "This post violates the community guidelines or terms of service.",
    "This post includes misinformation or false information.",
    "This post contains harmful or abusive language.",
    "This post promotes illegal activities or substances.",
    "This post infringes on intellectual property rights.",
    "Other",
  ];
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const authToken = localStorage.getItem("authToken");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onReportFormSubmit = (data, e) => {
    e.preventDefault();
    if (authToken) {
      const formData = {
        ...data,
        post_id: post?.id,
        token: authToken,
      };
      try {
        setIsSubmitting(true);
        http
          .post(`save-circle-post-report`, doObjToFormData(formData))
          .then((response) => {
            const data = response.data || response;
            if (data.status == 1) {
              toast.success(data.msg, TOAST_SETTINGS);
              setTimeout(() => {
                window.location.reload();
                setIsSubmitting(false);
              }, 2000);
            } else {
              toast.error(data.msg, TOAST_SETTINGS);
              setIsSubmitting(false);
            }
          });
      } catch (errors) {
        console.log("Errors", errors);
        setIsSubmitting(false);
      }
    } else {
      window.location.replace(paths.SITE_BASE_URL + "/signin");
    }
  };

  return (
    <div className="popup text_popup active">
      <div className="table_dv">
        <div className="table_cell">
          <div className="contain">
            <div className="_inner">
              <button
                type="button"
                className="x_btn"
                onClick={handleToggleReportPopup}
              ></button>
              <div className="heading_text">
                <h4>Report Post: {post.title}</h4>
              </div>
              <form method="POST" onSubmit={handleSubmit(onReportFormSubmit)}>
                <div className="form_row row">
                  {POST_REPORT_REASONS.map((reason, index) => (
                    <div className="col-sm-12" key={index}>
                      <div className="lbl_btn">
                        <input
                          type="radio"
                          {...register("reason", {
                            required: "Please select a reason.",
                          })}
                          value={reason}
                          id={`reason-${index}`}
                        />
                        <label htmlFor={`reason-${index}`}>{reason}</label>
                      </div>
                    </div>
                  ))}
                </div>
                <span className="validation-error">
                  {errors.reason?.message}
                </span>
                {watch("reason") === "Other" && (
                  <div>
                    <input
                      type="text"
                      className="input"
                      {...register("reason_other", {
                        required: "Please provide additional details.",
                      })}
                      placeholder="State the reason"
                    />
                    <span className="validation-error">
                      {errors.reason_other?.message}
                    </span>
                    <br></br>
                  </div>
                )}
                <div className="btn_blk text-center">
                  <button
                    className="site_btn"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <FormProcessingSpinner isFormProcessing={true} />
                        <span>Submit</span>
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportPopup2;
